module.exports = __webpack_public_path__ + "static/media/DevotchkaElephantClubFallTourposter2011Digitalprint.f5f6c118.webp";